import { fireAndForget } from '@core/util/fireAndForget';
import { queryReadyGate } from '@queries/gate';
import { useMcpServersQuery } from '@queries/mcp-servers';
import { usePipedreamConnectionsQuery } from '@queries/pipedream-connectors';
import { createMemo } from 'solid-js';
import { toConnectionsModel } from './model';

/** Present agent tool connections independently of personal accounts and harnesses. */
export function useConnectionsModel() {
  const pipedream = usePipedreamConnectionsQuery();
  const nativeMcp = useMcpServersQuery();
  const ready = () => pipedream.isFetched && nativeMcp.isFetched;
  const error = () =>
    ready() &&
    pipedream.isError &&
    nativeMcp.isError &&
    !queryReadyGate(pipedream) &&
    !queryReadyGate(nativeMcp);
  const partialError = () =>
    ready() && (pipedream.isError || nativeMcp.isError);
  const retry = () => {
    fireAndForget(pipedream.refetch(), 'connections-settings');
    fireAndForget(nativeMcp.refetch(), 'connections-settings');
  };
  const model = createMemo(() =>
    toConnectionsModel({
      pipedream: queryReadyGate(pipedream) ? pipedream.data : [],
      nativeMcp: queryReadyGate(nativeMcp) ? nativeMcp.data : [],
    })
  );
  return { model, ready, error, partialError, retry };
}
